import { create } from 'zustand';

interface DialogState {
    isWorkspaceDialogOpen: boolean;
    isProjectDialogOpen: boolean;
    isPriceDialogOpen: boolean;

    isCardDialogOpen: boolean;

    isWorkspaceConfirmDialogOpen: boolean;

    workspacePlan: '' | 'free' | 'basic' | 'pro' | 'ent' | null;
    selectedWorkspacePlan: '' | 'free' | 'basic' | 'pro' | 'ent' | null;

    isWorkspacePendingDialogOpen: boolean;

    openWorkspaceDialog: () => void;
    openProjectDialog: () => void;
    openPriceDialog: () => void;
    openWorkspacePendingDialog: () => void;

    closeWorkspaceDialog: () => void;
    closeProjectDialog: () => void;
    closePriceDialog: () => void;
    closeWorkspacePendingDialog: () => void;

    setWorkspaceDialog: (value: boolean) => void;
    setProjectDialog: (value: boolean) => void;
    setPriceDialog: (value: boolean) => void;

    setWorkspacePlan: (value: '' | 'free' | 'basic' | 'pro' | 'ent' | null) => void;
    setSelectedWorkspacePlan: (value: '' | 'free' | 'basic' | 'pro' | 'ent' | null) => void;

    setCardDialog: (value: boolean) => void;

    setWorkspacePendingDialog: (value: boolean) => void;

    openWorkspaceConfirmDialog: () => void;
    closeWorkspaceConfirmDialog: () => void;

    setWorkspaceConfirmDialogOpen: (value: boolean) => void;
}

export const useDialogStore = create<DialogState>(set => ({
    isWorkspaceDialogOpen: false,
    isProjectDialogOpen: false,
    isPriceDialogOpen: false,
    workspacePlan: null,
    isCardDialogOpen: false,
    isWorkspacePendingDialogOpen: false,
    selectedWorkspacePlan: null,
    isWorkspaceConfirmDialogOpen: false,

    openProjectDialog: () => set({ isProjectDialogOpen: true }),
    closeProjectDialog: () => set({ isProjectDialogOpen: false }),

    openWorkspaceDialog: () => set({ isWorkspaceDialogOpen: true }),
    closeWorkspaceDialog: () => set({ isWorkspaceDialogOpen: false }),

    openPriceDialog: () => set({ isPriceDialogOpen: true }),
    closePriceDialog: () => set({ isPriceDialogOpen: false }),

    openWorkspacePendingDialog: () => set({ isWorkspacePendingDialogOpen: true }),
    closeWorkspacePendingDialog: () => set({ isWorkspacePendingDialogOpen: false }),

    openWorkspaceConfirmDialog: () => set({ isWorkspaceConfirmDialogOpen: true }),
    closeWorkspaceConfirmDialog: () => set({ isWorkspaceConfirmDialogOpen: false }),

    setWorkspaceDialog: value => set({ isWorkspaceDialogOpen: value }),
    setProjectDialog: value => set({ isProjectDialogOpen: value }),
    setPriceDialog: value => set({ isPriceDialogOpen: value }),
    setWorkspacePlan: workspacePlan => set({ workspacePlan }),
    setSelectedWorkspacePlan: selectedWorkspacePlan => set({ selectedWorkspacePlan }),
    setCardDialog: isCardDialogOpen => set({ isCardDialogOpen }),
    setWorkspacePendingDialog: isWorkspacePendingDialogOpen => set({ isWorkspacePendingDialogOpen }),
    setWorkspaceConfirmDialogOpen: isWorkspaceConfirmDialogOpen => set({ isWorkspaceConfirmDialogOpen }),
}));
